import { jsonApiClient } from 'shared/model';
import { ScoreType } from '../@types';

const api = jsonApiClient('ScoreType');
export const getScoreTypes = (signal?: AbortSignal) => api.get<ScoreType[]>(undefined, { signal });
export const postScoreType = (id: string, scoreType: ScoreType) => api.post<ScoreType>(id, scoreType);
